module.exports = __webpack_public_path__ + "img/MGLogo-w.432d48e1.png";